var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',[(_vm.showLoading)?_c('ProgressBar',{staticStyle:{"height":"5px","color":"red"},attrs:{"mode":"indeterminate"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }